
import AboutUs1 from "./AboutUs/AboutUs1";
import AboutUs2 from "./AboutUs/AboutUs2";
import AboutUs3 from "./AboutUs/AboutUs3";
import ContactPage1 from "./Contact/ContactPage1";
import DestinationsList1 from "./DestinationLists/DestinationsList1";
import Destinations1 from "./Destinations/Destination1";
import Destinations2 from "./Destinations/Destination2";
import Destinations3 from "./Destinations/Destination3";
import Destinations10 from "./Destinations/Destinations10";
import Destinations4 from "./Destinations/Destinations4";
import Destinations5 from "./Destinations/Destinations5";
import Destinations6 from "./Destinations/Destinations6";
import Destinations7 from "./Destinations/Destinations7";
import Destinations8 from "./Destinations/Destinations8";
import Destinations9 from "./Destinations/Destinations9";
import FeaturedPackages1 from "./featured-packages/FeaturedPackages1";
import FeaturedPackages10 from "./featured-packages/FeaturedPackages10";
import FeaturedPackages11 from "./featured-packages/FeaturedPackages11";
import FeaturedPackages12 from "./featured-packages/FeaturedPackages12";
import FeaturedPackages2 from "./featured-packages/FeaturedPackages2";
import FeaturedPackages8 from "./featured-packages/FeaturedPackages8";
import FeaturedPackages9 from "./featured-packages/FeaturedPackages9";
import TemplateFooter1 from "./Footer/TemplateFooter1";
import TemplateFooter2 from "./Footer/TemplateFooter2";
import TemplateFooter3 from "./Footer/TemplateFooter3";
import TemplateHeaderHybrid from "./Header/TemplateHeader-Hybrid";
import TemplateHeaderHybrid2 from "./Header/TemplateHeader-Hybrid2";

import TemplateHeader1 from "./Header/TemplateHeader1";
import TemplateHeader10 from "./Header/TemplateHeader10";
import TemplateHeader2 from "./Header/TemplateHeader2";
import TemplateHeader3 from "./Header/TemplateHeader3";
import TemplateHeader4 from "./Header/TemplateHeader4";
import TemplateHeader5 from "./Header/TemplateHeader5";
import TemplateHeader6 from "./Header/TemplateHeader6";
import TemplateHeader7 from "./Header/TemplateHeader7";
import TemplateHeader8 from "./Header/TemplateHeader8";
import TemplateHeader9 from "./Header/TemplateHeader9";
import TemplateHeroTabbedSearch from "./Hero/TemplateHero-TabbedSearch";
import TemplateHeroTabbedSearch2 from "./Hero/TemplateHero-TabbedSearch2";

import TemplateHero1 from "./Hero/TemplateHero1";
import TemplateHero2 from "./Hero/TemplateHero2";
import TemplateHero20 from "./Hero/TemplateHero20";
import TemplateHero21 from "./Hero/TemplateHero21";
import TemplateHero23 from "./Hero/TemplateHero23";
import TemplateHero24 from "./Hero/TemplateHero24";
import TemplateHero25 from "./Hero/TemplateHero25";
import TemplateHero26 from "./Hero/TemplateHero26";
import TemplateHero27 from "./Hero/TemplateHero27";
import TemplateHero28 from "./Hero/TemplateHero28";
import TemplateHero29 from "./Hero/TemplateHero29";
import TemplateHero3 from "./Hero/TemplateHero3";
import TemplateHero4 from "./Hero/TemplateHero4";
import TemplateHero5 from "./Hero/TemplateHero5";
import TemplateHero6 from "./Hero/TemplateHero6";
import TemplateHero7 from "./Hero/TemplateHero7";
import TemplateHero22 from "./Hero/TemplateHero8";
import TemplateHero8 from "./Hero/TemplateHero8";
import PackageDetails1 from "./PackageDetails/PackageDetails1";
import PackagesListPage1 from "./PackagesList/PackagesListPage1";
import Testimonials1 from "./Testimonals/Testimonials1";
import Testimonials2 from "./Testimonals/Testimonials2";
import TopBar1 from "./TopBars/TopBar1";
import TopBar10 from "./TopBars/TopBar10";
import TopBar2 from "./TopBars/TopBar2";
import TopBar3 from "./TopBars/TopBar3";
import TopBar4 from "./TopBars/TopBar4";
import TopBar5 from "./TopBars/TopBar5";
import TopBar6 from "./TopBars/TopBar6";
import TopBar7 from "./TopBars/TopBar7";
import TopBar8 from "./TopBars/TopBar8";
import TopBar9 from "./TopBars/TopBar9";

export const componentMap = {
  TopBar1: TopBar1,
  TopBar2: TopBar2,
  TopBar3: TopBar3,
  TopBar4: TopBar4,
  TopBar5: TopBar5,
  TopBar6: TopBar6,
  TopBar7:TopBar7,
  TopBar8: TopBar8,
  TopBar9: TopBar9,
  TopBar10: TopBar10,

  
  TemplateHeader1: TemplateHeader1,
  TemplateHeader2: TemplateHeader2,
  TemplateHeader3: TemplateHeader3,
  TemplateHeader4: TemplateHeader4,
  TemplateHeader5: TemplateHeader5,
  TemplateHeader6: TemplateHeader6,
  TemplateHeader7: TemplateHeader7,
  TemplateHeader8: TemplateHeader8,
  TemplateHeader9: TemplateHeader9,
  TemplateHeader10: TemplateHeader10,

  TemplateHeaderHybrid: TemplateHeaderHybrid,
  TemplateHeaderHybrid2: TemplateHeaderHybrid2,

  TemplateHero1: TemplateHero1,
  TemplateHero2: TemplateHero2,
   TemplateHero3: TemplateHero3,
    TemplateHero4: TemplateHero4,
     TemplateHero5: TemplateHero5,
      TemplateHero6: TemplateHero6,
       TemplateHero7: TemplateHero7,
        TemplateHero8: TemplateHero8,
        TemplateHero20: TemplateHero20,
        TemplateHero21: TemplateHero21,
        TemplateHero22: TemplateHero22,
        TemplateHero23: TemplateHero23,
        TemplateHero24: TemplateHero24,
        TemplateHero25: TemplateHero25,
        TemplateHero26: TemplateHero26,
        TemplateHero27: TemplateHero27,
        TemplateHero28: TemplateHero28,
        TemplateHero29: TemplateHero29,


  TemplateHeroTabbedSearch: TemplateHeroTabbedSearch,
  TemplateHeroTabbedSearch2: TemplateHeroTabbedSearch2,

  FeaturedPackages1: FeaturedPackages1,
  FeaturedPackages2: FeaturedPackages2,
  FeaturedPackages9: FeaturedPackages9,
  FeaturedPackages8: FeaturedPackages8,
  FeaturedPackages10: FeaturedPackages10,
  FeaturedPackages11: FeaturedPackages11,
  FeaturedPackages12: FeaturedPackages12,


  PackageDetails1: PackageDetails1, 

  Destinations1 : Destinations1,
  Destinations2: Destinations2,
  Destinations3: Destinations3,
  Destinations4: Destinations4,
 Destinations5: Destinations5,
 Destinations6: Destinations6,
 Destinations7: Destinations7,
 Destinations8: Destinations8,
 Destinations9: Destinations9,
 Destinations10: Destinations10,

 
  DestinationsList1: DestinationsList1,

  PackagesListPage1: PackagesListPage1,


  Testimonials1: Testimonials1,
  Testimonials2: Testimonials2,
  
  AboutUs1: AboutUs1,
  AboutUs2: AboutUs2,
  AboutUs3: AboutUs3,

  ContactPage1: ContactPage1,

  TemplateFooter1: TemplateFooter1,
  TemplateFooter2: TemplateFooter2,
  TemplateFooter3: TemplateFooter3,

  // When you create HeaderB, you will add it here
};